export const MODAL_SHOW = "modal/MODAL_SHOW";
export const MODAL_HIDE = "modal/MODAL_HIDE";
export const CAROUSAL_SHOW = "modal/CAROUSAL_SHOW";
export const CAROUSAL_HIDE = "modal/CAROUSAL_HIDE";
export const MODAL_SCREEN_SHOW = "modal/MODAL_SCREEN_SHOW";
export const SEARCH_EDIT = "modal/SEARCH_EDIT";
export const HISTORY_POP = "modal/HISTORY_POP";
export const SCREENS_PUSH = "modal/SCREENS_PUSH";
